"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendDataToIframe = exports.receiveMessage = void 0;
const receiveMessage = (showIFrame, getGameData) => async (event) => {
    if (!showIFrame)
        return;
    (0, exports.sendDataToIframe)(event, getGameData());
};
exports.receiveMessage = receiveMessage;
const sendDataToIframe = (event, gameData) => {
    let data;
    try {
        data = JSON.parse(event.data);
    }
    catch (_a) { }
    if (!data || data.type !== 'poGame')
        return;
    switch (data.name) {
        case 'onGameReadyHandler': {
            const iframe = document.getElementById('iframe');
            iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow.postMessage(JSON.stringify({
                type: 'poGameParent',
                name: 'setGameConfig',
                data: gameData
            }), '*');
            return console.warn('***** onGameReadyHandler');
        }
        default:
            return;
    }
};
exports.sendDataToIframe = sendDataToIframe;
//# sourceMappingURL=iframe-utils.js.map